/**
 * Services section showcasing Web3 and AI offerings
 */
function Services() {
	const services = [
		{
			icon: '⛓️',
			title: 'Blockchain Development',
			description: 'Smart contracts, DeFi protocols, and custom blockchain solutions built for scale and security.'
		},
		{
			icon: '🤖',
			title: 'AI Integration',
			description: 'Machine learning models and AI-powered features that enhance user experiences and automate workflows.'
		},
		{
			icon: '🎨',
			title: 'dApp Design',
			description: 'User-centric interfaces for decentralized applications that bridge complexity with simplicity.'
		},
		{
			icon: '🔐',
			title: 'Security Audits',
			description: 'Comprehensive smart contract audits and security assessments to protect your digital assets.'
		},
		{
			icon: '📊',
			title: 'Data Analytics',
			description: 'On-chain and off-chain analytics solutions providing actionable insights for your business.'
		},
		{
			icon: '🚀',
			title: 'Product Strategy',
			description: 'End-to-end consulting to bring your Web3 and AI vision from concept to market.'
		}
	];

	return (
		<section id="services" className="services">
			<div className="section-container">
				<h2 className="section-title">What We Build</h2>
				<p className="section-subtitle">
					Combining blockchain technology with artificial intelligence to create next-generation solutions
				</p>
				<div className="services-grid">
					{services.map((service, index) => (
						<div key={index} className="service-card">
							<span className="service-icon">{service.icon}</span>
							<h3 className="service-title">{service.title}</h3>
							<p className="service-description">{service.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default Services;
